"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DialogStyleProvider: ()=>DialogStyleProvider
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_DialogStyleContext_js_namespaceObject = require("./DialogStyleContext.js");
const DialogStyleProvider = ({ children })=>{
    const topLevelBoxStyle = {
        width: '100%',
        height: 'calc(100% - 133px)',
        style: {
            position: 'absolute',
            top: '65px',
            overflowY: 'scroll',
            overflowX: 'hidden'
        },
        borderBottom: '1px solid #c0cad5'
    };
    const contentFlexStyle = {
        pb: 2,
        px: 3,
        width: '100%',
        minHeight: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-end'
    };
    const inputStyle = {
        width: '100%',
        style: {
            position: 'absolute',
            bottom: '0px'
        },
        position: 'absolute',
        bottom: '0px'
    };
    const recordingIndicatorStyle = {
        height: '290px',
        circleHeight: '161px',
        circleWidth: '161px'
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DialogStyleContext_js_namespaceObject.StyleContext.Provider, {
        value: {
            topLevelBoxStyle,
            contentFlexStyle,
            inputStyle,
            recordingIndicatorStyle
        },
        children: children
    });
};
exports.DialogStyleProvider = __webpack_exports__.DialogStyleProvider;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DialogStyleProvider"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
